import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import { toast } from "react-toastify";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthGreaterThan,
  hasLengthLessThan,
  matchesPattern,
} from "revalidate";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import TextInput from "../../../../app/common/form/TextInput";
import { IUsers, IUserCompany } from "../../../../app/models/user";
import { observer } from "mobx-react-lite";

const validate = combineValidators({
  "name": composeValidators(
    isRequired({ message: "El Nombre es obligatorio" }),
    matchesPattern(/^[A-zÀ-ÿ \-]*$/)({
      message:
        "Solo se permiten caracteres alfanuméricos",
    }),
    hasLengthLessThan(65)({
      message: "El Nombre debe tener máximo 64 caracteres",
    }),
    hasLengthGreaterThan(1)({
      message: "El Nombre debe tener al menos 2 caracteres",
    }),
  )(),
  "lastName": composeValidators(
    isRequired({ message: "El Apellido es obligatorio" }),
    matchesPattern(/^[A-zÀ-ÿ \-]*$/)({
      message:
        "Solo se permiten caracteres alfanumérico",
    }),
    hasLengthLessThan(65)({
      message: "El Apellido debe tener máximo 64 caracteres",
    }),
    hasLengthGreaterThan(1)({
      message: "El Apellido debe tener al menos 2 caracteres",
    }),
  )(),
  "phone": composeValidators(
    isRequired({ message: "El Teléfono es obligatorio" }),
    matchesPattern(/^[a-zA-Z0-9\.()-\\]*$/)({
      message:
        "Teléfono no válido. Contiene espacios o caracteres especiales diferente a: ( ) - . \\",
    }),
    hasLengthGreaterThan(6)({
      message: "El Teléfono debe tener al menos 7 caracteres",
    }),
    hasLengthLessThan(33)({
      message: "El Teléfono debe tener máximo 32 caracteres",
    })
  )(),
  "email": composeValidators(
    isRequired({ message: "El Email es obligatorio" }),
    matchesPattern(/^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/)({
      message: "Por favor digite un Email valido",
    }),
    hasLengthLessThan(257)({
      message: "El Email debe tener máximo 256 caracteres",
    }),
    hasLengthGreaterThan(5)({
      message: "El Email debe tener al menos 6 caracteres",
    }),
  )(),
});

interface IProps {
  user: IUsers;
}

const EditUserAdminForm: React.FC<IProps> = ({ user }) => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { editAdminUser } = rootStore.userCompanyStore;
  const { loading } = rootStore.buttonLoadingStore;

  const [editUserAdminForm] = useState<IUserCompany>({
      username: user.username,
      name: user.name,
      lastName: user.lastName,
      phone: user.phone,
      email: user.email,
  });
  const handleFinalFormSubmit = (values: any) => {   
    if (
      values.email !== editUserAdminForm.email ||
      values.name !== editUserAdminForm.name ||
      values.lastName !== editUserAdminForm.lastName ||
      values.phone !== editUserAdminForm.phone 
    ) {
      values.name = values.name.trim();
      values.lastName = values.lastName.trim();
      values.email = values.email.trim();
      values.phone = values.phone.trim();
      editAdminUser(user.id, values);
    } else toast.error("No ha hecho ningún cambio");
  };
  return (
    <div className="modalContent">
      <FinalForm
        validate={validate}
        initialValues={editUserAdminForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Usuario de acceso</label>
              <Field
                name="username"
                disabled={true}
                value={editUserAdminForm.username}
                component={TextInput}
              />
              <label>Nombres</label>
              <Field
                name="name"
                value={editUserAdminForm.name}
                component={TextInput}
              />
              <label>Apellidos</label>
              <Field
                name="lastName"
                value={editUserAdminForm.lastName}
                component={TextInput}
              />
              <label>Teléfono</label>
              <Field
                name="phone"
                value={editUserAdminForm.phone}
                component={TextInput}
              />
              <label>Mail notificaciones</label>
              <Field
                name="email"
                value={editUserAdminForm.email}
                component={TextInput}
              />
              
              <br />
              <br />
              <Button
                loading={loading}
                disabled={loading}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Guardar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(EditUserAdminForm);
